import { type FC } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import { TextField, type TextFieldProps } from "widgets";

import { fieldIsInvalid } from "../../../app-utils/form.js";
import { charsLeftMessage } from "../../../app-utils/string.js";

export interface ITextFieldFormProps extends Partial<WrappedFieldProps>, TextFieldProps {}

/**
 * Text field to be used in context of redux-form
 */
const TextFieldForm: FC<ITextFieldFormProps> = (props) => {
  const message =
    props.meta.dirty && props.maxLength
      ? charsLeftMessage(props.maxLength, (props.input.value as string).length, 5)
      : null;

  return (
    <TextField
      {...props}
      {...props.input}
      isInvalid={fieldIsInvalid(props)}
      errorMessage={props.meta.error}
      description={message ?? props.description}
      onChange={props.input.onChange}
      onBlur={(e) => {
        const t = e.target.value;
        props.input.onBlur(t?.trim());
      }}
    />
  );
};

export default function TextReduxFormField(props: ITextFieldFormProps & BaseFieldProps) {
  return <Field {...props} component={TextFieldForm} />;
}
